/**
 * P0 — Audio Sync education card surfaced on Home so the differentiator
 * is visible without requiring the user to discover it in the header.
 * Dispatches `vs:open-audio-sync` which the AudioSyncButton listens for
 * to open the existing manual sync sheet.
 */
import { useEffect } from "react";
import { Radio } from "lucide-react";
import { trackEvent } from "@/lib/audit";

export function AudioSyncEduCard() {
  useEffect(() => {
    void trackEvent("audio_sync_card_shown", {});
  }, []);

  const onTry = () => {
    void trackEvent("audio_sync_card_cta_clicked", {});
    try {
      window.dispatchEvent(new CustomEvent("vs:open-audio-sync"));
    } catch { /* noop */ }
  };

  return (
    <div className="rounded-2xl border border-primary/40 bg-gradient-to-br from-primary/15 via-background to-accent/10 p-3 shadow-md">
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground">
          <Radio className="h-4 w-4" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-black uppercase tracking-widest text-primary">
            📺 Sincroniza tu TV
          </div>
          <div className="text-sm font-black leading-tight">
            Evita spoilers.
          </div>
          <div className="mt-0.5 text-[11px] text-muted-foreground">
            Controla exactamente cuándo escuchar cada jugada.
          </div>
          <button
            type="button"
            onClick={onTry}
            className="mt-2 inline-flex items-center gap-1 rounded-lg bg-primary px-3 py-1.5 text-[11px] font-black text-primary-foreground transition hover:scale-[1.02] active:scale-95"
          >
            Probar Audio Sync
          </button>
        </div>
      </div>
    </div>
  );
}
